// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"84e42cad","332":"37a86a14","395":"d52eea40","419":"09566d6d","802":"d52eea40","964":"be5485b8"}[chunkId] + ".chunk.css";
};